<span matSnackBarLabel>
    Pour installer l'application, cliquer sur le bouton <mat-icon>ios_share</mat-icon> puis "Sur l'écran d'accueil <mat-icon>add_box</mat-icon>"
</span>
<span matSnackBarActions>
    <button style="margin-left:auto; margin-right:auto" mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">Fermer</button>
</span>